import { useLocation } from 'react-router-dom';

import { useCreateUrl } from '@/hooks/useNavigate';

import type { SidebarMenuItemConfig } from '../../types';

const getActiveSegments = (pathname: string): string[] => {
  const [, ...segments] = pathname.substring(1).split('/');
  return segments;
};

const useSidebarMenu = (_routes: SidebarMenuItemConfig[]) => {
  const location = useLocation();
  const createUrl = useCreateUrl();

  const activeSegments = getActiveSegments(location.pathname);
  const currentPath = activeSegments.join('/');

  const isActive = (path: string): boolean =>
    currentPath === path || currentPath.startsWith(`${path}/`);

  const isSubItemActive = (parentPath: string, childPath: string, fullPath?: string, queryParam?: string): boolean => {
    const resolvedPath = fullPath ?? (childPath ? `${parentPath}/${childPath}` : parentPath);

    if (!childPath && !fullPath) {
      if (queryParam) {
        return currentPath === parentPath && location.search.includes(queryParam);
      }
      return currentPath === parentPath;
    }

    const pathMatches = currentPath === resolvedPath || currentPath.startsWith(`${resolvedPath}/`);
    if (!pathMatches) return false;
    if (queryParam) return location.search.includes(queryParam);
    return true;
  };

  return { isActive, isSubItemActive, createUrl };
};

export default useSidebarMenu;
